import { createSlice } from "@reduxjs/toolkit";

export const initialRoleLocalState = {
  role: {
    count: "",
  },
};

export const roleSlice = createSlice({
  name: "role",
  initialState: {
    roles: [],
    isRoleResponse: false,
    isAddRoleSuccess: false,
    isDeleteRoleSuccess: false,
    isReassignRoleSuccess: false,
    moduleLists: [],
    isRoleError: false,
    newRoleLocal: initialRoleLocalState,
  },

  reducers: {
    getAllRoles: (state) => {},
    setAllRoles: (state, { payload }) => {
      console.log("worker-payload", payload);
      state.roles = payload;
    },

    getAllModules: (state) => {},
    setAllModules: (state, { payload }) => {
      console.log("module-payload", payload);
      state.moduleLists = payload;
    },

    addRoleAction: (state, { payload }) => {},
    setAddRoleResponse: (state, { payload }) => {
      console.log("addWorkerResponse", payload);
      state.isAddRoleSuccess = payload;
    },
    updateRoleAction: (state, { payload }) => {
      console.log("updateWorkers", payload);
    },

    updateRoleResponse: (state, { payload }) => {
      console.log("response-payload", payload);
      state.isRoleResponse = payload;
    },

    deleteRoleAction: (state, { payload }) => {},
    setDeleteRoleResponse: (state, { payload }) => {
      state.isDeleteRoleSuccess = payload;
    },

    reassignRoleAction: (state, { payload }) => {},
    setReassignRoleResponse: (state, { payload }) => {
      state.isReassignRoleSuccess = payload;
    },

    getAllRoleById: (state, { payload }) => {},
    setNewRoleLocal: (state, action) => {
      console.log("action", action);
      state.newRoleLocal = {
        ...state.newRoleLocal,
        ...action.payload,
      };
    },

    resetNewWorkerLocal: (state) => {
      state.newRoleLocal = initialRoleLocalState;
    },
  },
});

const {
  getAllRoles,
  setAllRoles,
  addRoleAction,
  getAllModules,
  setAllModules,
  setAddRoleResponse,
  updateRoleAction,
  updateRoleResponse,
  deleteRoleAction,
  setDeleteRoleResponse,
  reassignRoleAction,
  setReassignRoleResponse,
  getAllRoleById,
  setNewRoleLocal,
  resetNewWorkerLocal,
} = roleSlice.actions;

export {
  getAllRoles,
  setAllRoles,
  addRoleAction,
  getAllModules,
  setAllModules,
  setAddRoleResponse,
  updateRoleAction,
  updateRoleResponse,
  deleteRoleAction,
  setDeleteRoleResponse,
  reassignRoleAction,
  setReassignRoleResponse,
  getAllRoleById,
  setNewRoleLocal,
  resetNewWorkerLocal,
};

export default roleSlice.reducer;
